import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createPlantMaster,
  listPlantMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 発電所マスタ新規登録 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 */
export function useCreatePlantMaster(): InvalidatingMutationResultFor<
  typeof createPlantMaster
> {
  return useInvalidatingMutation(createPlantMaster, [
    createConnectQueryKey({ schema: listPlantMasters, cardinality: 'finite' }),
  ])
}
